import React, { forwardRef, useEffect } from 'react';
import LanguageUtils from '../../../utils/LanguageUtils';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../common/widgets/loader';
import WorkflowUtils from '../../../utils/workflowUtils';
import PageUtils from '../../../utils/pageUtils';
import GenericTextField from '../../common/widgets/genericTextField';
import { getIsLoadingUsers, fetchUsersWithoutSeller, getUsersWithoutSeller } from '../../../reducers/userReducer';
import GenericAutocomplete from '../../common/widgets/genericAutocomplete';
import { Grid } from '@mui/material';
import SellerStep1Validation from './validations/sellerStep1Validation';
import Seller from '../../../interfaces/output/seller';
import UserOut from '../../../interfaces/output/userOut';
import UserFilters from '../../../interfaces/filters/userFilters';
import { isCreatingSeller, isLoadingSeller, isUpdatingSeller } from '../../../reducers/sellerReducer';
interface ISellerStep1Props {
    seller: Seller;
    onChange: any;
    showValidationError?: boolean
}

const ATTRIBUTES = {
    NAME: 'name',
    SSO_NAME: 'ssoId',
    USER_ID: 'userId'

};

const messages = {
    name: LanguageUtils.createMessage('Name'),
    ssoName: LanguageUtils.createMessage('Sso name'),
    user: LanguageUtils.createMessage('User')
};

const SellerFormStep1 = forwardRef((props: ISellerStep1Props, ref: any): JSX.Element => {
    const { seller, onChange, showValidationError } = props;
    const paging = PageUtils.getMaxPaging();
    const filters = {} as UserFilters;
    const dispatch = useDispatch();
    const isLoadingObjects = [useSelector(isCreatingSeller), useSelector(isLoadingSeller),
        useSelector(isUpdatingSeller), useSelector(getIsLoadingUsers)];
    const isLoading = isLoadingObjects.find((obj: boolean) => obj === true);
    const users = useSelector(getUsersWithoutSeller).content;
    WorkflowUtils.setHandle(ref, null);

    useEffect(() => {
        dispatch(fetchUsersWithoutSeller({
            paging,
            filters
        }));
    }, [dispatch]);

    const setValidationState = (attribute: string) => {
        let isValid = true;

        if(!showValidationError || !attribute) {
            return undefined;
        }

        switch (attribute) {

            case ATTRIBUTES.NAME: {
                isValid = SellerStep1Validation.validateInputString(seller.name);
                break;
            }
            case ATTRIBUTES.SSO_NAME: {
                isValid = SellerStep1Validation.validateInputString(seller.ssoName);
                break;
            }
            case ATTRIBUTES.USER_ID: {
                isValid = SellerStep1Validation.validateInputNumber(seller.userId);
                break;
            }
        }

        return !isValid;
    };

    return (
        <Loader isLoading={isLoading}>
            <Grid container spacing={2} mt={2}>
                <Grid item xs={3} />
                <Grid item xs={12} sm={6}>
                    <GenericTextField<string>
                        type="string"
                        name="name"
                        label={messages.name}
                        value={seller.name}
                        onChange={onChange}
                        error={setValidationState(ATTRIBUTES.NAME)}
                        required
                    />
                </Grid>
                <Grid item xs={3} />
                <Grid item xs={3} />
                <Grid item xs={12} sm={6}>
                    <GenericTextField<string>
                        type="string"
                        name="ssoName"
                        label={messages.ssoName}
                        value={seller.ssoName}
                        onChange={onChange}
                        error={setValidationState(ATTRIBUTES.SSO_NAME)}
                        required
                    />
                </Grid>
                <Grid item xs={3} />
                <Grid item xs={3} />
                <Grid item xs={12} sm={6}>
                    <GenericAutocomplete<UserOut>
                        options={users}
                        value={seller.userId}
                        onChange={(obj: UserOut | null) => onChange('userId', obj?.id)}
                        placeholder={messages.user}
                        error={setValidationState(ATTRIBUTES.USER_ID)}
                        compareFn={(o: UserOut) => o.id === seller.userId}
                    />
                </Grid>
                <Grid item xs={3} />
            </Grid>
        </Loader >
    );
});

export default SellerFormStep1;